import React from "react";
import { TitledContent } from "./TitledContent";
import { defineMessage, FormattedMessage } from "react-intl";
import { useLoaderData } from "react-router-dom";
import { Stack, Typography } from "@mui/material";
import { ListResult } from "../utils/crud";
import audit from "../descriptors/audit";
import List from "./List";
import JsonView from "react-json-view";
import StringFilter from "./StringFilter";

const AuditPage: React.FC = () => {
    const data = useLoaderData() as ListResult;
    const descriptor = audit;
    const resourceName = "audit";

    return (
        <TitledContent title={<FormattedMessage id="audit.list" defaultMessage="Audit log" />}>
            <Stack spacing={2}>
                <StringFilter filterField="free" placeholder={defineMessage({ id: "user.filter_placeholder", defaultMessage: "Search for login name, alias, or full name.." })} />
                <List
                    data={data.rows}
                    maxPage={Math.ceil(data.count / descriptor.listDefaults.limit)}
                    header={descriptor.orders.list}
                    uri={new URL(window.location.href)}
                    renderers={descriptor.renderers?.list}
                    fieldNameKeyFactory={(fieldName: string) => `${resourceName}.fields.${fieldName}`}
                    collapseRenderer={(row) => {
                        if (!row.details) {
                            return null;
                        }

                        return (
                            <div>
                                <Typography variant="h5" gutterBottom>
                                    Details
                                </Typography>
                                <JsonView
                                    src={row.details}
                                    name={false} // do not display "root" name
                                    indentWidth={4}
                                    collapsed={1}
                                    displayDataTypes={false}
                                    enableClipboard={false}
                                    displayObjectSize={false}
                                    style={{
                                        fontSize: "1em",
                                    }}
                                />
                            </div>
                        );
                    }}
                />
            </Stack>
        </TitledContent>
    );
};

export default AuditPage;
